import { KeyValueModel } from "model/api";
import { EnumPDVTpCaixa } from "model/enums/enum-pdv-tpcaixa";

export const TpCaixaMock: KeyValueModel[] = [
    new KeyValueModel(EnumPDVTpCaixa.WEBPDV, "WebPDV"),
    new KeyValueModel(EnumPDVTpCaixa.SAURUSPDV, "PDV integrado"),
    new KeyValueModel(EnumPDVTpCaixa.ANDROID, "Android"),
];
